import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Typo from 'constants/typography'
import { locizeTranslation } from 'lib/utils/locize'
import { withI18next } from 'lib/i18n/withI18next'
import styles from './styles.scss'
import SIZE_GUIDES from './const'

const SizesGuidesInfomation = ({ t }) => (
  <Fragment>
    <style jsx>{styles}</style>
    {SIZE_GUIDES.map(({ title, description }, index) => (
      <div className="info-container" key={`${index}_title`}>
        <span className={Typo.subtitle2}>{locizeTranslation(t, title)}</span>
        <span className={Typo.body2}>{locizeTranslation(t, description)}</span>
      </div>
    ))}
  </Fragment>
)

SizesGuidesInfomation.propTypes = {
  t: PropTypes.func.isRequired,
}

export default withI18next()(SizesGuidesInfomation)
